export default {
  path: '/production-plan',
  name: 'ProductionPlan',
  component: () => import('@/views/productionPlan/index.vue'),
  redirect: '/production-plan/time-and-action',
  children: [
    {
      path: 'overview',
      name: 'ProductionPlanOverview',
      component: () => import('@/views/productionPlan/pages/Overview.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    },
    {
      path: 'old',
      name: 'ProductionPlanOld',
      component: () => import('@/views/productionPlan/pages/OldProductionPlan.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'graphic',
          'merchandiser',
          'designer',
          'creative'
        ]
      }
    },
    {
      path: 'time-and-action/:collectionId?',
      name: 'TimeAndAction',
      component: () => import('@/views/productionPlan/pages/TimeAndAction.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    },
    {
      path: 'gantt/:prototypeId',
      name: 'ProductionPlanGantt',
      component: () => import('@/views/productionPlan/pages/Gantt.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    },
    {
      path: 'workflow',
      name: 'Workflow',
      component: () => import('@/views/productionPlan/pages/Workflow.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner'
        ]
      }
    },
    {
      path: 'custom-field',
      name: 'ProductionPlanCustomField',
      component: () => import('@/views/productionPlan/pages/CustomField.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner'
        ]
      }
    },
    {
      path: 'health-check',
      name: 'HealthCheck',
      component: () => import('@/views/productionPlan/pages/HealthCheck.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    },
    {
      path: 'my-completion-rate',
      name: 'MyCompletionRate',
      component: () => import('@/views/productionPlan/pages/MyCompletionRate.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    },
    {
      path: 'calendar',
      name: 'ProductionPlanCalendar',
      component: () => import('@/views/productionPlan/pages/Calendar.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'merchandising_planner',
          'designer',
          'merchandiser',
          'graphic',
          'creative',
          'vm',
          'marketing'
        ]
      }
    }
  ]
}
